import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import {
  Button,
  TextField,
  Table,
  TableBody,
  AppBar,
  Toolbar,
  Typography,
  TableCell,
  TableContainer, Box, Container,
  TableHead,
  TableRow, Modal,
  Paper,
  InputAdornment,
  TablePagination,
} from "@mui/material";
import LoadingBar from "react-top-loading-bar";
import SearchIcon from "@mui/icons-material/Search";
import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";
import Tooltip from "@mui/material/Tooltip";
import base64 from "base64-js";
import Snackbar from '@mui/material/Snackbar';
import MuiAlert from '@mui/material/Alert';

const Alert = React.forwardRef(function Alert(props, ref) {
  return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});


const ManageRoute = () => {
  const navigate = useNavigate();
  const { encodedFormId } = useParams();
  console.log("encodedFormId:", encodedFormId);
  const [snackbarSeverity, setSnackbarSeverity] = useState("success");
  const [openSnackbar, setOpenSnackbar] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState('');
  const [categories, setCategories] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [routeToDelete, setRouteToDelete] = useState("");
  const [loadingBarProgress, setLoadingBarProgress] = useState(0);
  const [canEdit, setCanEdit] = useState(false);
  const [canDelete, setCanDelete] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [authorization, setAuthorization] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);

  // Decode the encodedFormId
  const decodeFormId = (encodedFormId) => {
    const bytes = base64.toByteArray(encodedFormId);
    return new TextDecoder().decode(bytes);
  };
  const formId = decodeFormId(encodedFormId);

  const fetchCategories = async (searchTerm = "", pageNumber = 1, pageSize = 10) => {
    try {
      setLoadingBarProgress(30);
      const apiUrl = process.env.REACT_APP_BASE_URL;

      const response = await fetch(`${apiUrl}/Transportation/Route/GetRoutes`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: sessionStorage.getItem("token"),
        },
        body: JSON.stringify({
          searchTerm,
          pageNumber,
          pageSize,
        }),
      });

      if (response.ok) {
        const responseData = await response.json();
        console.log("Categories fetched:", responseData);
        setCategories(responseData.routes || []);
      } else {
        console.error("Failed to fetch categories:", response.status);
      }
    } catch (error) {
      console.error("Error fetching categories:", error);
    } finally {
      setLoadingBarProgress(100);
      setIsLoading(false);
    }
  };


  const Authorizer = async () => {
    try {
      const apiUrl = process.env.REACT_APP_BASE_URL;
      setLoadingBarProgress(30);
      const token = sessionStorage.getItem("token");
      console.log("Sending decoded formId:", formId);

      const response = await fetch(`${apiUrl}/CPanel/Module_Authorizer`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: token,
        },
        body: JSON.stringify({
          formId,
        }),
      });

      if (response.ok) {
        const responseData = await response.json();
        setAuthorization(responseData);
        const authorizationData = responseData[0];
        setCanDelete(authorizationData.uDelete === 1);
        setCanEdit(authorizationData.uModify === 1);
        setLoadingBarProgress(100);
      } else {
        console.error("Authorization failed:", response.status);
        // alert("Invalid authorization response");
         setSnackbarMessage("Invalid authorization response");
      setSnackbarSeverity("error");
      setOpenSnackbar(true);
        setLoadingBarProgress(0);
      }
    } catch (error) {
      console.error("API request error:", error);
      // alert("An error occurred. Please try again later.");
       setSnackbarMessage("An error occurred. Please try again later.");
      setSnackbarSeverity("error");
      setOpenSnackbar(true);

      setLoadingBarProgress(0);
    }
  };

  const handleClose = () => {
    setShowModal(false);
  }
  const handleAddCategory = () => {
    navigate("/manage-route/add", { state: { encodedFormId } });
  };

  const handleDeleteCategory = async (routeID) => {
    if (!canDelete) {
      // alert("You don’t have permission to delete Route.");
       setSnackbarMessage("You don’t have permission to delete Route.");
      setSnackbarSeverity("error");
      setOpenSnackbar(true);
      return;
    }



    try {
      const apiUrl = process.env.REACT_APP_BASE_URL;
      const response = await fetch(
        `${apiUrl}/Transportation/Route/${routeID}`,
        {
          method: "DELETE",
          headers: {
            Authorization: sessionStorage.getItem("token"),
          },
        }
      );

      if (response.ok) {
        setCategories(
          categories.filter((cat) => cat.routeID !== routeID)
        );
        setShowModal(false);
        setSnackbarMessage('Routes deleted successfully!');
        setOpenSnackbar(true);
      } else {
        // alert("Failed to delete Route");
         setSnackbarMessage("Failed to delete Route");
      setSnackbarSeverity("error");
      setOpenSnackbar(true);
      }
    } catch (error) {
      console.error("Error deleting Route:", error);
      // alert("An error occurred while deleting the route");
      setSnackbarMessage("An error occurred while deleting the route");
      setSnackbarSeverity("error");
      setOpenSnackbar(true);
    }
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  useEffect(() => {
    console.log("Component mounted, fetching data...");
    fetchCategories();
    Authorizer();
  }, []);

  const filteredCategories = categories.filter((category) =>
  (category.routeName?.toLowerCase().includes(searchTerm.toLowerCase()) ||
    category.description?.toLowerCase().includes(searchTerm.toLowerCase()))
  );

  const paginatedCategories = filteredCategories.slice(
    page * rowsPerPage,
    page * rowsPerPage + rowsPerPage
  );

  return (
    <Container>
      <LoadingBar
        progress={loadingBarProgress}
        color="rgb(152, 106, 182)"
        height={5}
      />
      <AppBar position="static" style={{ backgroundColor: "#0B1F40" }}>
        <Toolbar>
          <Typography variant="h4" component="div" style={{ fontWeight: "bold" }}>
            Manage Route
          </Typography>


        </Toolbar>
      </AppBar>

      <Paper elevation={3} style={{ padding: 16, marginTop: 6 }}>
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            marginBottom: 16,
          }}
        >
          <TextField
            variant="outlined"
            placeholder="Search Routes..."
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <SearchIcon />
                </InputAdornment>
              ),
            }}
            sx={{ width: 300, backgroundColor: "#f9f9f9" }}
          />
          <Button
            variant="contained"
            color="primary"
            onClick={handleAddCategory}
          >
            Add Routes
          </Button>
        </div>

        {isLoading ? (
          <Typography>Loading Routes...</Typography>
        ) : (
          <>
            <TableContainer
              component={Paper}
              style={{

                marginTop: "16px",
                border: '1px solid #ccc'
              }}
            >
              <Table sx={{ minWidth: 650 }}>
                <TableHead>
                  <TableRow>
                    <TableCell sx={{ borderRight: '1px solid #ccc', borderBottom: '1px solid #ccc', fontWeight: 'bold', fontSize: '1.1rem', backgroundColor: '#f5f5f5', width: "30%" }}>
                      Route Name
                    </TableCell>
                    <TableCell sx={{ borderRight: '1px solid #ccc', borderBottom: '1px solid #ccc', fontWeight: 'bold', fontSize: '1.1rem', backgroundColor: '#f5f5f5', width: "40%" }}>
                      Description
                    </TableCell>
                    <TableCell sx={{ borderRight: '1px solid #ccc', borderBottom: '1px solid #ccc', fontWeight: 'bold', fontSize: '1.1rem', backgroundColor: '#f5f5f5', width: "30%", minWidth: 200, textAlign: 'center' }}>
                      Actions
                    </TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {paginatedCategories.length > 0 ? (
                    paginatedCategories.map((category) => (
                      <TableRow key={category.routeID} sx={{ borderTop: '1px solid #ccc' }}>
                        <TableCell sx={{ borderRight: '1px solid #ccc', fontSize: '1rem', whiteSpace: "normal", wordWrap: "break-word" }}>
                          {category.routeName || "N/A"}
                        </TableCell>
                        <TableCell sx={{ borderRight: '1px solid #ccc', fontSize: '1rem', whiteSpace: "normal", wordWrap: "break-word" }}>
                          {category.description || "N/A"}
                        </TableCell>
                        <TableCell sx={{ borderRight: '1px solid #ccc', fontSize: '1rem', textAlign: 'center' }}>
                          <Tooltip title={canEdit ? "" : "Not authorized to edit"} arrow>
                            <span>
                              <Button
                                variant="contained"
                                color="warning"
                                onClick={() => navigate(`/manage-route/edit/${category.routeID}`)}
                                disabled={!canEdit}
                                sx={{ marginRight: 1, minWidth: 80 }}
                                startIcon={<EditIcon />}
                              >
                                Edit
                              </Button>
                            </span>
                          </Tooltip>
                          <Tooltip title={canDelete ? "" : "Not authorized to delete"} arrow>
                            <span>
                              <Button
                                variant="contained"
                                color="error"
                                onClick={() => { setRouteToDelete(category.routeID); setShowModal(true) }}

                                disabled={!canDelete}
                                sx={{ minWidth: 80 }}
                                startIcon={<DeleteIcon />}

                              >
                                Delete
                              </Button>
                            </span>
                          </Tooltip>
                        </TableCell>
                      </TableRow>
                    ))
                  ) : (
                    <TableRow>
                      <TableCell colSpan={3} sx={{ textAlign: 'center' }}>No Routes available</TableCell>
                    </TableRow>
                  )}
                </TableBody>
              </Table>
            </TableContainer>

            <TablePagination
              rowsPerPageOptions={[5, 10, 25]}
              component="div"
              count={filteredCategories.length}
              rowsPerPage={rowsPerPage}
              page={page}
              onPageChange={handleChangePage}
              onRowsPerPageChange={handleChangeRowsPerPage}
            />
          </>
        )}
      </Paper>

      <Modal open={showModal} onClose={handleClose} aria-labelledby="delete-modal-title" aria-describedby="delete-modal-description">
        <Box
          sx={{
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            width: 400,
            bgcolor: 'background.paper',
            borderRadius: 2,
            boxShadow: 24,
            overflow: 'hidden',
          }}
        >
          {/* Header */}
          <Box sx={{ backgroundColor: '#0B1F40', padding: '12px 16px' }}>
            <Typography id="delete-modal-title" variant="h6" sx={{ color: '#fff' }}>
              Delete Confirmation ⚠️
            </Typography>
          </Box>

          {/* Content */}
          <Box sx={{ padding: '20px' }}>
            <Typography id="delete-modal-description" sx={{ mb: 2 }}>
              Are you sure you want to delete this Route?
            </Typography>

            {/* Buttons */}
            <Box sx={{ display: 'flex', justifyContent: 'flex-end', mt: 3 }}>
              <Button onClick={handleClose} variant="outlined" sx={{ mr: 1 }}>
                Cancel
              </Button>
              <Button
                variant="contained"
                color="error"
                onClick={() => handleDeleteCategory(routeToDelete)}
              >
                Yes, Delete
              </Button>
            </Box>
          </Box>
        </Box>
      </Modal>

      <Snackbar
        open={openSnackbar}
        autoHideDuration={4000}
        onClose={() => setOpenSnackbar(false)}
        anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
      >
        <Alert onClose={() => setOpenSnackbar(false)} severity={snackbarSeverity} sx={{ width: '100%' }}>
          {snackbarMessage}
        </Alert>
      </Snackbar>


    </Container>
  );
};

export default ManageRoute;
